import React, {Component} from 'react';
import * as settings from "../../settings";

export default class SuggestionsItem extends Component {
    constructor(props) {
        super(props);
        this.onLinkMouseDown = this.onLinkMouseDown.bind(this);
        this.getMarkup = this.getMarkup.bind(this);
        this.escapeRegExp = this.escapeRegExp.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
    }

    onLinkMouseDown(e) {
        e.preventDefault();
        e.target.click();
    }

    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    getMarkup(text) {
        let query = this.props.query.toLowerCase();
        let regExp = new RegExp(`(${this.escapeRegExp(query)})`, 'gi');
        let parts = text.split(regExp);

        return (
            <span>
                {parts.map((part, i) => part.toLowerCase() === query ?
                    <mark key={i}>{part}</mark> : part
                )}
            </span>
        );
    }

    handleMouseDown(event) {
        event.stopPropagation();

        let target = event.target.classList.contains("search-component__suggestions-text") ?
                         event.target : event.target.closest(".search-component__suggestions-text");

        this.props.matchInputToSuggestionPick(target.childNodes[0].textContent);
        this.props.handleSuggestionClick(target);
    }

    render() {
        let itemContent;
        let searchableLabel;
        let nonSearchableLabel;

        if(this.props.searchableLabel) {
            searchableLabel = (
                <span className="search-component__suggestions-info">
                     {this.getMarkup(this.props.searchableLabel)}
                 </span>
            );
        }

        if(this.props.nonSearchableLabel) {
            nonSearchableLabel = (
                <span className="search-component__suggestions-info">
                    {this.props.nonSearchableLabel}
                </span>
            );
        }

        if(this.props.url && !this.props.handleSuggestionClick) {
            itemContent = <a href={this.props.url}
                             target="_self"
                             onMouseDown={this.onLinkMouseDown}>
                              <span className="search-component__suggestions-link">
                                  {this.getMarkup(this.props.content)}
                              </span>
                              {nonSearchableLabel}
                              {searchableLabel}
                          </a>
        } else {
            itemContent = <span tabIndex="0"
                                className="search-component__suggestions-text"
                                data-pointid={this.props.pointId}
                                onMouseDown={this.handleMouseDown}>
                              <span>
                                  {this.getMarkup(this.props.content)}
                              </span>
                              {nonSearchableLabel}
                              {searchableLabel}
                          </span>
        }

        return (
            <li className="search-component__suggestions-item">
                {itemContent}
            </li>
        )
    }
}
